module.exports = __webpack_public_path__ + "static/media/edit.7e1ee3c4.svg";